import styled from 'styled-components';

export const DotsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing['4']}px;
`;

export const Indicator = styled.div<{ $isActive: boolean }>`
  width: ${({ theme, $isActive }) => {
    return $isActive ? theme.spacing['4'] : theme.spacing['2'];
  }}px;
  height: 8px;
  background-color: ${({ theme, $isActive }) => {
    const color = $isActive ? 'accent' : 'neutral';
    return theme.colors[color][color]['11'];
  }};
  border-radius: 6px;
  transition: all 0.3s ease;
  cursor: pointer;
`;
